import { renderApp } from 'app';

document.addEventListener('DOMContentLoaded', () => {
	const root = document.getElementById('root');
	if (root) renderApp(root);
});